function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import isPropValid from "@emotion/is-prop-valid";
import { styled } from "@mui/material";
import { forwardRef } from "react";
var StyledModalContainer = styled('div', {
    shouldForwardProp: isPropValid
})(function(props) {
    var _props_lgWidth, _props_mdWidth;
    var _obj;
    return _obj = {
        '& > form': {
            display: 'contents'
        },
        /** WCAG 1.4.10 */ '@media (max-height: 500px)': {
            overflowY: 'auto'
        },
        backgroundColor: 'white',
        borderRadius: '0.75rem',
        boxShadow: '0 0 #0000, 0 0 #0000, 0px 4px 48px #0006',
        display: 'flex',
        flexDirection: 'column',
        margin: props.theme.spacing(4),
        maxHeight: 'calc(100% - 1rem)',
        outline: 'none',
        position: 'relative',
        width: (_props_lgWidth = props.lgWidth) !== null && _props_lgWidth !== void 0 ? _props_lgWidth : '44rem'
    }, _define_property(_obj, props.theme.breakpoints.down('md'), {
        width: (_props_mdWidth = props.mdWidth) !== null && _props_mdWidth !== void 0 ? _props_mdWidth : '44rem'
    }), _define_property(_obj, props.theme.breakpoints.down('sm'), {
        width: '100%'
    }), _obj;
});
export var ModalContainer = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsx(StyledModalContainer, _object_spread_props(_object_spread({}, props), {
        ref: ref,
        children: props.children
    }));
});
ModalContainer.displayName = 'ModalContainer';

//# sourceMappingURL=ModalContainer.js.map